import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { cn } from "@omni/utils/styles";
import { useWatch } from "react-hook-form";
import { useSelector } from "react-redux";

import { CheckoutCustomerFormValues } from "@/components/Checkout/CheckoutCustomer/checkoutCustomer.schema";
import { CheckBoxField } from "@/components/Form/RHF/FormFields/CheckboxField/CheckBoxField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import * as CartSelectors from "@/redux/modules/api/data/cart/cart.selectors";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const RequestInvoice = ({ className }: Props) => {
    const { t } = useGranite();

    const customerType = useWatch<CheckoutCustomerFormValues>({
        name: "customerType"
    });

    const customer = useSelector(CustomerSelectors.isCustomerFilledIn);
    const isCnCOnly = useSelector(CartSelectors.isClickAndCollectOnly);

    const isB2B = customer && customerType === ComponentsCustomerType.B2B;

    if (!isCnCOnly || isB2B) return;

    return (
        <section className={cn(className)}>
            <Row>
                <Col>
                    <CheckBoxField<CheckoutCustomerFormValues>
                        name={"requestInvoice"}
                        required={false}
                        label={t(
                            "checkout.customerDetails.requestInvoice.label"
                        )}
                    />
                </Col>
            </Row>
        </section>
    );
};
